import { render, staticRenderFns } from "./monitoring2Detail.vue?vue&type=template&id=049be9ca"
import script from "./monitoring2Detail.vue?vue&type=script&lang=js"
export * from "./monitoring2Detail.vue?vue&type=script&lang=js"
import style0 from "./monitoring2Detail.vue?vue&type=style&index=0&id=049be9ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports